<template>
    <Navbar></Navbar>
    <div class="contact-hero">
        <div class="contact-us-title">
            加入我们
        </div>
        <div class="contact-hero-inner">
            <div class="contact-hero-card">
                <div class="contact-hero-inner-item">
                    <div class="contact-hero-company">蜂巢汽车科技集团有限公司</div>
                    <div class="contact-hero-addr">地&nbsp;&nbsp;&nbsp;址：河北省保定市莲池区东二环东盛路75号</div>
                    <div class="contact-hero-addr">邮&nbsp;&nbsp;&nbsp;箱：fczp@finestauto.com</div>
                    <div class="contact-hero-addr">联系人：王经理</div>
                    <div class="contact-hero-addr">电&nbsp;&nbsp;&nbsp;话：18531241011</div>
                </div>
            </div>
            <div class="contact-hero-map">
                <div class="map-img" @click="openMap">
                    <img class="pc-pad" data-src="/assets/contact/map.jpg" alt="contact map">
                    <img class="mb-only" data-src="/assets/contact/map-m.jpg" alt="contact map">
                </div>
            </div>
        </div>
    </div>

    <!-- 地图选择弹窗 -->
    <div v-if="showMapPopup" class="map-popup-mask" @click.self="closeMapPopup">
        <div class="map-popup">
            <div class="map-popup-title">选择地图应用</div>
            <div class="map-popup-item" @click="goAmapApp">高德地图</div>
            <div class="map-popup-item" @click="goBaiduMapApp">百度地图</div>
            <div class="map-popup-item" @click="goTencentMap">腾讯地图</div>
            <div class="map-popup-cancel" @click="closeMapPopup">取消</div>
        </div>
    </div>

    <div class="contact-us">
        <div class="contact-us-tab">
            <div class="contact-tab-item" v-for="(item, index) in pageData" :key="index"
                :class="activeTab == index + 1 ? 'active' : ''" @click="activeTab = index + 1">
                <div class="contact-us-title-text">
                    {{ item.title }}
                </div>
                <div class="contact-us-desc">
                    <div class="contact-us-type">
                        {{ item.type }}
                    </div>
                    <div class="contact-us-address">
                        <img data-src="/assets/contact/address-icon.png" alt="" class="contact-us-address-icon">
                        <div>
                            {{ item.location }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="contact-us-container">
            <div class="us-container-item" v-for="(item, index) in pageData" :key="index"
                v-show="activeTab == index + 1">
                <div class="container-item-title">
                    职位描述
                </div>
                <div class="container-item-content">

                    <div class="container-item-address">
                        <div class="container-item-address-type">
                            {{ item.type }}
                        </div>
                        <img data-src="/assets/contact/address-icon.png" alt="" class="contact-us-address-icon">
                        <div class="container-item-address-text">
                            {{ item.location }}
                        </div>
                    </div>

                    <div class="container-item-time">
                        {{ item.time }}
                    </div>

                </div>

                <div class="container-item-responsibility">
                    岗位职责
                </div>
                <div class="container-item-desc" v-for="(content, contentIndex) in item.content" :key="contentIndex">
                    {{ content }}
                </div>

                <div class="container-item-responsibility">
                    岗位要求
                </div>
                <div class="container-item-desc" v-for="(value, valueIndex) in item.requirement" :key="valueIndex">
                    {{ value }}
                </div>

            </div>

        </div>
    </div>


    <Footer></Footer>
</template>

<script setup>
import { ref, reactive } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

const activeTab = ref(1);
const pageData = reactive([
    {
        title: '精益管理工程师',
        type: '全职',
        location: '河北省·保定市',
        time: '2026-01-20 发布',
        content: [
            '① 负责制定与推进公司精益生产年度/月度计划，监督生产体系实施与优化',
            '② 完善工艺流程与管理标准，组织生产协调与调度，确保生产效率提升和目标达成',
        ],
        requirement: [
            '① 5年以上车辆制造行业精益生产经验，熟悉冲压工艺、设备及精益管理模式',
            '② 具备较强的沟通、组织和逻辑思维能力，熟练使用办公软件',
        ]
    },
    {
        title: '质量专家',
        type: '全职',
        location: '河北省·保定市',
        time: '2026-01-20 发布',
        content: [
            '① 负责公司质量管理体系的策划、建立、完善与监督执行',
            '② 制定质量方针、政策和目标，指导日常管理并推动改进',
            '③ 组织实施项目、体系及过程审核，识别风险并落实改进措施',
        ],
        requirement: [
            '① 要求本科及以上学历，10年以上汽车或零部件行业质量/技术相关经验，精通IATF16949、VDA6.3及APQP、FMEA等工具',
            '② 接受机械、汽车、质量、机电、材料、自动化、电子等相关专业',
        ]
    }, {
        title: '诊断功能标定总工',
        type: '全职',
        location: '河北省·保定市',
        time: '2026-01-20 发布',
        content: [
            '① 统筹诊断标定流程体系建设，主导核心系统诊断开发实施',
            '② 推动全球技术标准落地应用，协调跨部门重大问题攻关',
            '③ 组织专业人才梯队培养建设',
            '④ 管理项目节点与交付质量，建立故障快速响应机制',
        ],
        requirement: [
            '① 具备TCU/MCU/ACU诊断标定开发10年以上，熟悉全球诊断开发通用流程，并具有量产开发经验',
            '② 掌握UDS、OBD等诊断协议，掌握模型开发和测试标定工具',
            '③ 具备诊断完整开发流程者优先，具备海外项目协作经验者优先',
            '④ 良好的团队管理与沟通能力、抗压能力',
        ]
    },

]);

const isPc = ref(window.innerWidth > 768);
const showMapPopup = ref(false);

// 目标地址：蜂巢汽车科技集团有限公司 保定市莲池区东二环东盛路75号
const targetAddr = "蜂巢汽车科技集团有限公司";
const lat = 38.88822;
const lon = 115.52144;

const openMap = () => {
    if (!isPc.value) {
        showMapPopup.value = true;
    }
}
const closeMapPopup = () => {
    showMapPopup.value = false;
}

// 高德APP跳转
const goAmapApp = () => {
    closeMapPopup();
    const appUrl = `amapuri://route/plan/?sid=&slat=&slon=&sname=&dlat=${lat}&dlon=${lon}&dname=${encodeURIComponent(targetAddr)}&dev=0&m=0`;
    const webUrl = `https://amap.com/navi?dest=${lat},${lon}&destname=${encodeURIComponent(targetAddr)}`;
    window.location.href = appUrl;
    setTimeout(() => {
        if (document.visibilityState === 'visible') { // 页面还在前台才跳转网页
            window.location.href = webUrl;
        }
    }, 2000);
}

// 百度地图APP跳转
const goBaiduMapApp = () => {
    closeMapPopup();
    const bdLat = 38.89412;
    const bdLon = 115.52781;
    const appUrl = `baidumap://map/direction?mode=driving&dest-name=${encodeURIComponent(targetAddr)}&dest-lat=${bdLat}&dest-lon=${bdLon}`;
    const webUrl = `https://api.map.baidu.com/direction?origin=&destination=name:${encodeURIComponent(targetAddr)}|latlng:${bdLat},${bdLon}&mode=driving&output=html&src=your_web_name`;
    window.location.href = appUrl;
    setTimeout(() => {
        if (document.visibilityState === 'visible') { // 页面还在前台才跳转网页
            window.location.href = webUrl;
        }
    }, 2000);
}

// 腾讯地图app 修复缺失跳转
const goTencentMap = () => {
    closeMapPopup();
    const scheme = `qqmap://map/routeplan?type=drive&fromcoord=CurrentLocation&to=${encodeURIComponent(targetAddr)}&tocoord=${lat},${lon}`;
    const webUrl = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&to=${encodeURIComponent(targetAddr)}&tocoord=${lat},${lon}`;
    window.location.href = scheme;
    setTimeout(() => {
        if (document.visibilityState === 'visible') { // 页面还在前台才跳转网页
            window.location.href = webUrl;
        }
    }, 2000);
}

</script>

<script>
export const pageConfig = {
    title: '加入我们 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'join-us.html'
};

import { createApp } from 'vue';
import App from './join-us.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./join-us.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped>
.contact-hero {
    padding: 2.1rem 1.56rem 0rem;
    width: calc(100% - 3.12rem);

    .contact-us-title {
        font-size: 0.4rem;
        font-weight: 500;
        color: #000;
        margin-bottom: 0.4rem;
    }

    .contact-hero-inner {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
    }

    .contact-hero-card {
        width: 49.3%;
        border-radius: 0.25rem;
        background: #F6F8FA;
        display: flex;
        flex-direction: column;

        .contact-hero-inner-item {
            padding: 0.58rem 0.44rem;
        }

        .contact-hero-title {
            font-size: 0.5rem;
            font-weight: 500;
            margin-bottom: 0.3rem;
        }

        .contact-hero-company {
            font-size: 0.28rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 0.56rem;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 0.38rem;
                height: 0.02rem;
                background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                bottom: -0.2rem;
                left: 0;
            }
        }

        .contact-hero-addr {
            font-size: 0.16rem;
            color: #999;
            line-height: 0.3rem;
        }
    }

    .contact-hero-map {
        width: 49.3%;

        .map-img {
            width: 100%;
            height: 100%;
            border-radius: 0.25rem;
            overflow: hidden;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                // display: block;
            }
        }
    }


}

.contact-us {
    padding: 0.25rem 1.56rem;
    width: calc(100% - 3.12rem);
    display: flex;
    gap: 0.25rem;

    .contact-us-tab {
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        flex-direction: column;
        width: auto;
        gap: 0.24rem;

        .contact-tab-item {
            width: 2.2rem;
            min-height: 0.62rem;
            background: #F6F8FA;
            border-radius: 0.15rem;
            padding: 0.36rem 0.44rem;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            transition: all 0.5s;
            cursor: pointer;
            gap: 0.2rem;
            border: 1px solid #F6F8FA;

            &.active {
                background: rgba(231, 0, 18, 0.04);
                border: 1px solid #E70012;
            }

            .contact-us-title-text {
                font-size: 0.25rem;
                font-weight: 600;
                color: #000;
            }

            .contact-us-desc {
                display: flex;
                width: 100%;

                .contact-us-type {
                    font-size: 0.18rem;
                    color: #000;
                    font-weight: 400;
                    position: relative;
                    margin-right: 0.3rem;

                    &::after {
                        content: '';
                        position: absolute;
                        width: 0.01rem;
                        height: 0.14rem;
                        background: #D5D5D5;
                        right: -0.15rem;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }

                .contact-us-address {
                    display: flex;
                    align-items: center;

                    img.contact-us-address-icon {
                        width: 0.16rem;
                        height: 0.16rem;
                        margin-right: 0.1rem;
                    }

                    div {
                        font-size: 0.18rem;
                        color: #000;
                    }
                }
            }
        }
    }

    .contact-us-container {
        width: 11.68rem;
        min-height: 4.5rem;
        position: relative;

        .us-container-item {
            position: sticky;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
            min-height: 4.37rem;
            background: #F6F8FA;
            border-radius: 0.15rem;
            padding: 0.36rem 0.53rem;

            .container-item-title {
                font-weight: bold;
                font-size: 0.25rem;
                color: #000000;
            }

            .container-item-content {
                margin-top: 0.2rem;
                display: flex;
                justify-content: space-between;

                .container-item-address {
                    display: flex;
                    align-items: center;

                    .container-item-address-type {
                        font-weight: 400;
                        font-size: 0.18rem;
                        margin-right: 0.58rem;
                        position: relative;

                        &::after {
                            content: '';
                            width: 0.02rem;
                            height: 0.14rem;
                            background: #D5D5D5;
                            position: absolute;
                            right: -0.29rem;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }

                    .contact-us-address-icon {
                        width: 0.16rem;
                        height: 0.16rem;
                    }

                    .container-item-address-text {
                        font-weight: 400;
                        font-size: 0.16rem;
                        margin-left: 0.05rem;
                    }

                }

                .container-item-time {
                    font-weight: 400;
                    font-size: 0.18rem;
                    color: #999;
                }

            }

            .container-item-responsibility {
                margin-top: 0.46rem;
                font-weight: bold;
                font-size: 0.2rem;
                color: #000000;
                margin-bottom: 0.23rem;
            }

            .container-item-desc {
                font-weight: 400;
                font-size: 0.18rem;
                color: #000000;
                line-height: 0.3rem;
                margin-bottom: 0.1rem;
            }
        }
    }

}

// 地图选择弹窗样式
.map-popup-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.map-popup {
    width: 100%;
    background: #fff;
    border-radius: 0.24rem 0.24rem 0 0;
    overflow: hidden;
}

.map-popup-title {
    text-align: center;
    font-size: 0.28rem;
    padding: 0.3rem 0;
    font-weight: 500;
    border-bottom: 1px solid #eee;
}

.map-popup-item {
    text-align: center;
    font-size: 0.26rem;
    padding: 0.32rem 0;
    border-bottom: 1px solid #eee;
    cursor: pointer;
}

.map-popup-cancel {
    text-align: center;
    font-size: 0.26rem;
    padding: 0.32rem 0;
    color: #666;
    background: #f7f7f7;
    cursor: pointer;
}

@media (max-width: 768px) {
    .contact-hero {
        padding: 2.02rem 0.45rem 0;
        width: calc(100% - 0.9rem);

        .contact-hero-inner {
            flex-direction: column-reverse;
            background: #F6F8FA;

            .contact-hero-card {
                width: 100%;

                .contact-hero-addr {
                    font-size: 0.2rem;
                    color: #000;
                }
            }

            .contact-hero-map {
                width: 100%;
            }
        }
    }

    .contact-us {
        flex-direction: column;
        padding: 0.5rem 0.45rem;
        width: calc(100% - 0.9rem);

        .contact-us-tab {
            width: 100%;
            flex-direction: row;

            .contact-tab-item {
                width: auto;
                padding: 0.2rem 0.29rem;
                min-height: auto;

                .contact-us-title-text {
                    font-size: 0.22rem;
                }

                .contact-us-desc {
                    display: none;
                }
            }
        }

        .contact-us-container {
            width: 100%;

            .us-container-item {
                padding: 0.2rem 0.29rem;
                width: calc(100% - 0.58rem);

                .container-item-title {
                    font-size: 0.28rem;
                }

                .container-item-content {
                    .container-item-address {

                        .container-item-address-type {
                            font-size: 0.2rem;
                        }

                        .container-item-address-text {
                            font-size: 0.2rem;
                        }
                    }

                    .container-item-time {
                        font-size: 0.2rem;
                    }
                }

                .container-item-responsibility {
                    font-size: 0.28rem;
                }

                .container-item-desc {
                    font-size: 0.2rem;
                }
            }

        }
    }

    .map-popup {
        width: 100%;
    }
}
</style>